<template>
  <div class="footnav">
    <ul>
      <li><a class="alp" href="https://www.asagaku.com/" target="_blank"><span></span>朝日学生新聞社</a></li>
      <li><a class="alp" href="http://www.asagaku.com/jc_policy.html" target="_blank"><span></span>プライバシーポリシー</a></li>
      <li><a class="alp" href="mailto:concours@asagaku.co.jp"><span></span>お問い合わせ：concours@asagaku.co.jp</a></li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

.footnav {
  padding: 45px 0 50px;
  ul {
    width: 86.6%;
    max-width: 780px;
    margin: 0 auto;
    @include flex();
  }
  li {
    font-weight: bold;
    font-size: 12px;
  }
  a {
    display: block;
    line-height: 1;
    letter-spacing: 0.1em;
    padding-left: 23px;
    position: relative;
    span {
      display: inline-block;
      position: absolute;
      top:calc(50% - 7px);
      left: 0;
      width: 15px;
      height: 15px;
      background: #000;
    }
    span:before {
      content: " ";
      width: 0;
      height: 0;
      display: block;
      border: 4.5px dashed transparent;
      border-left: 6px solid #fff;
      margin: 3px 0 0 5px;
    }
  }
  li:nth-of-type(3) {
    font-weight: bold;
    position: relative;
    letter-spacing: 0.15em;
    span {
      display: block;
      position: absolute;
      top: calc(50% - 6px);
      left: 0;
      width: 22px;
      height: 14px;
      background: url(../assets/img/common/ico_mail.png) no-repeat left center;
      background-size: 100% auto;
      &:before {
        display: none;
      }
    }
    a {
      padding-left: 30px;
      letter-spacing: 0.15em;
    }
  }
  @media only screen and (max-width: 750px) {
    padding: 0;
    ul {
      display: block;
      width: 100%;
      max-width: 100%;
      li {
        padding-left: 5.35vw;
        border-top: 1px solid #e5e5e5;
        a {
          line-height: 4.6em;
          font-size: 1.025rem;
          letter-spacing: 0.15rem;
          padding-left: 6.7vw;
          span {
            top: calc(50% - 0.6em);
            width: 4vw;
            height: 4vw;
          }
          span:before {
            border: 1.2vw dashed transparent;
            border-left: 1.5vw solid #fff;
            margin: 0;
            position: absolute;
            top: calc(50% - 1.2vw);
            left: calc(50% - 0.7vw);
          }
        }
      }
      li:nth-of-type(3) {
          font-size: 1.025rem;
        padding-left: 5.35vw;
        span {
          top: calc(50% - 6px);
          width: 5vw;
          height: 3.3vw;
        }
        a {
          letter-spacing: 0.15em;
        }
      }
    }
  }
}

@media only screen and (max-width: 750px) {
}
</style>

<script>
export default {
  name: "footnav"
};
</script>
